import { h } from './dom.js';

// What identifies the site, read from its settings: logos, contact details, and the values pages of text can use.

/** The logo pictures to show. A site may give one logo for dark pages and another for light pages. */
export function logoImages(design, alt = '') {
  const base = design['brand.logo'];
  const dark = design['brand.logo_on_dark'] || base;
  const light = design['brand.logo_on_light'] || base;
  if (!dark && !light) return [];
  if (dark === light) return [h('img', { src: dark, alt })];
  return [dark ? h('img', { src: dark, alt, class: 'logo-for-dark' }) : null, light ? h('img', { src: light, alt, class: 'logo-for-light' }) : null].filter(Boolean);
}

const digits = (v) => String(v).replace(/[^0-9]/g, '');

/** The contact details the site has, each with where it leads. */
export function contactItems(design) {
  const items = [];
  const email = design['contact.email'];
  const phone = design['contact.phone'];
  const whatsapp = design['contact.whatsapp'];
  if (email) items.push({ kind: 'email', text: email, href: `mailto:${email}` });
  if (phone) items.push({ kind: 'phone', text: phone, href: `tel:${phone.trim().startsWith('+') ? '+' : ''}${digits(phone)}` });
  if (whatsapp) items.push({ kind: 'whatsapp', text: whatsapp, href: `https://wa.me/${digits(whatsapp)}` });
  if (design['contact.address']) items.push({ kind: 'address', text: design['contact.address'] });
  if (design['contact.hours']) items.push({ kind: 'hours', text: design['contact.hours'] });
  return items;
}

/** Values a page of text may use, such as {email} or {company}, so its words follow the settings. */
export function pageVariables(design, site) {
  const company = design['brand.company'] || site.name;
  const email = design['contact.email'];
  const phone = design['contact.phone'];
  const whatsapp = design['contact.whatsapp'];
  return {
    name: site.name,
    company,
    domain: site.domain,
    year: String(new Date().getFullYear()),
    email: email ? `[${email}](mailto:${email})` : '',
    phone: phone ? `[${phone}](tel:${phone.trim().startsWith('+') ? '+' : ''}${digits(phone)})` : '',
    whatsapp: whatsapp ? `[${whatsapp}](https://wa.me/${digits(whatsapp)})` : '',
    address: design['contact.address'] || '',
    hours: design['contact.hours'] || '',
  };
}
